// ============================================================
// RUNTIME MODE — Production vs Demo detection
// ============================================================
// "Demo mode" means the portal is running on mock data with no
// real Cognito / Stripe / Starlink backends. Used to:
//   1. Show a banner so users know what they're looking at
//   2. Gate destructive actions (no real reboots, no real charges)
//   3. Pre-fill demo accounts and demo MFA codes
//
// The runtime decides by checking env vars set at build time:
//   VITE_COGNITO_USER_POOL_ID set       → real auth
//   VITE_STRIPE_PUBLISHABLE_KEY set     → real payments
//   VITE_API_BASE set + USE_MOCK_API false → real Starlink data

const MODE = (() => {
  const env = import.meta.env || {};
  const realAuth     = !!env.VITE_COGNITO_USER_POOL_ID;
  const realPayments = !!env.VITE_STRIPE_PUBLISHABLE_KEY;
  const realData     = env.VITE_USE_MOCK_API === 'false' && !!env.VITE_API_BASE;
  return {
    realAuth, realPayments, realData,
    isDemo: !realAuth && !realPayments && !realData,
    isProduction: realAuth && realPayments && realData,
    isHybrid: !((!realAuth && !realPayments && !realData) || (realAuth && realPayments && realData)),
  };
})();

export function getRuntimeMode() { return MODE; }
export function isDemoMode() { return MODE.isDemo; }
export function isProductionMode() { return MODE.isProduction; }

export const COGNITO_CONFIG = {
  userPoolId:  import.meta.env?.VITE_COGNITO_USER_POOL_ID,
  clientId:    import.meta.env?.VITE_COGNITO_CLIENT_ID,
  domain:      import.meta.env?.VITE_COGNITO_DOMAIN,
  redirectSignIn:  import.meta.env?.VITE_COGNITO_REDIRECT_SIGN_IN || `${typeof window !== 'undefined' ? window.location.origin : ''}/`,
  redirectSignOut: import.meta.env?.VITE_COGNITO_REDIRECT_SIGN_OUT || `${typeof window !== 'undefined' ? window.location.origin : ''}/login`,
};

export const STRIPE_CONFIG = {
  publishableKey: import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY,
  paymentIntentEndpoint: '/api/payments/create-intent',
};

export const API_CONFIG = {
  base: import.meta.env?.VITE_API_BASE || '/api',
  operationsBase: import.meta.env?.VITE_OPERATIONS_API_BASE || import.meta.env?.VITE_API_BASE || '/api',
  useMock: import.meta.env?.VITE_USE_MOCK_API !== 'false',
};
